if($('.card-color__menu').length > 0 && $(window).width() < 768) {
	$('.nav__item').on('click', function() {
		$(this).toggleClass('checked');
		$(this).siblings().removeClass('checked');
	})
}